"use strict";

var _defineProperty = require("/home/circleci/project/frontends/frontdoor/node_modules/@babel/runtime/helpers/defineProperty.js");

var _objectWithoutProperties = require("/home/circleci/project/frontends/frontdoor/node_modules/@babel/runtime/helpers/objectWithoutProperties.js");

var _excluded = ["color"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);

  __setModuleDefault(result, mod);

  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconEllipse = void 0;

var React = __importStar(require("react"));

exports.IconEllipse = React.forwardRef(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      props = _objectWithoutProperties(_ref, _excluded);

  return React.createElement("svg", _objectSpread(_objectSpread({
    width: "36",
    height: "8",
    viewBox: "0 0 36 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    ref: forwardedRef
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.30769 4C8.30769 6.20832 6.4471 8 4.15384 8C1.86059 8 -2.01035e-06 6.20832 -1.91011e-06 4C-1.80986e-06 1.79168 1.86059 -1.43701e-06 4.15384 -1.34048e-06C6.4471 -1.24395e-06 8.30769 1.79168 8.30769 4ZM22.1538 4C22.1538 6.20832 20.2933 8 18 8C15.7067 8 13.8462 6.20832 13.8462 4C13.8462 1.79168 15.7067 -8.54192e-07 18 -7.57664e-07C20.2933 -6.61135e-07 22.1538 1.79168 22.1538 4ZM36 4C36 6.20832 34.1394 8 31.8462 8C29.5529 8 27.6923 6.20832 27.6923 4C27.6923 1.79168 29.5529 -2.71374e-07 31.8462 -1.74845e-07C34.1394 -7.83168e-08 36 1.79168 36 4Z",
    fill: color
  }));
});